import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SocoHttpService, ApiResult } from '@app/base/soco';
import { GasRequestStatusViewModel } from '@app/modules/landing/base/models/request-status.model';
import { AcceptContractModel } from '@app/base/shared/models/applicant/gas-contract-model';
import { GasAvailabilityLetterModel } from '@app/base/shared/models/letter.model';
import { BuilderInfoOne, Gasbca } from '@app/core/models';
import { TrackerStepsStatusViewModel } from '@app/modules/landing/base/models/tracker-steps-status.model';
import { Feedback } from '@app/core/models/app/feedback.model';
import { Kmi } from '@app/modules/landing/base/models/Kmi.model';
import { KMIUpdate } from '../models/KMIUpdate.model';
import { KMI_Configurations } from '../models/KMI_Configrations.model';
/* istanbul ignore next */
@Injectable({
  providedIn: 'root'
})
export class LandingService {

  // used to trigger the GetGasContractInfoEmail method from the API to get the contract details
  getBcaContractInfoeMail(email: string): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'applicant/GetGasContractInfoEmail',
      params: { emailId: email },
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter1'
    });
  }

  constructor(private http: SocoHttpService) { }

  // used to trigger API method GasRequestStatus to get the status of the request
  getBcaStatusById(id: number): Observable<ApiResult<GasRequestStatusViewModel>> {
    return this.http.get<GasRequestStatusViewModel>({
      url: 'applicant/GasRequestStatus',
      params: { id: id },
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }

  //CXCO-888 & CXCO-890 used to trigger API method GetApproachByIdAsync to get the approch type and steps of the request
  getGasApproachById(id: number): Observable<ApiResult<TrackerStepsStatusViewModel[]>> {
    return this.http.get<TrackerStepsStatusViewModel[]>({
      url: 'applicant/GetApproachByIdAsync',
      params: { id: id },
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }
  

  addBuilder(model: BuilderInfoOne): Observable<ApiResult<any>> {
    return this.http.post<BuilderInfoOne>({
      url: 'Common/AddBuilderCompanyAsync',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing',
      pleaseWaitContainerId: 'ContainerAwaiter2'

    });
  }
  addUser(addUser: any): Observable<ApiResult<any>> {
    return this.http.post<BuilderInfoOne>({
      url: 'Common/AddBuilderUserAsync',
      data: addUser,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing',
      pleaseWaitContainerId: 'ContainerAwaiter2'

    });
  }
  getBuilderCompany(builderCompany: string): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Common/BuilderCompany',
      params: { builderCompany: builderCompany },
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }
  // used to trigger the GetGasContractInfo method from the API to get the contract details
  getBcaContractInfo(id: number): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'applicant/GetGasContractInfo',
      params: { id: id },
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }
  getPwrNumber(bcaId: number): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'applicant/GetPwrNumber',
      params: { id: bcaId },
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }

  // used to trigger PostGasLetterRequestAsync in the API to save gas letter details
  postGasLetter(model: GasAvailabilityLetterModel): Observable<ApiResult<GasAvailabilityLetterModel>> {
    return this.http.post<GasAvailabilityLetterModel>({
      url: 'Common/PostGasLetterRequestAsync',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }

  // used to trigger AcceptRejectContractAsync in the API to save the contract accepted/rejected details
  postGasContract(model: AcceptContractModel): Observable<ApiResult<AcceptContractModel>> {
    return this.http.post<AcceptContractModel>({
      url: 'applicant/AcceptRejectContractAsync',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }

  // used to trigger the GetHolidayList method from the API to get the holiday list
  getHolidayList(): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'applicant/GetHolidayList',
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });

  }

  // CXCO-1159
  postFeedback(model: Feedback): Observable<ApiResult<any>> {    
    return this.http.post<Feedback>({
      url: 'Common/PostFeedbackAsync',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }
  putFeedback(model: Feedback): Observable<ApiResult<any>> {    
    return this.http.put<Feedback>({
      url: 'Common/PutFeedbackAsync',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }
  // CXCO-1159
  getFeedbackByProjectId(id: number): Observable<ApiResult<any>> {
      return this.http.get<Feedback[]>({
      url: 'Common/GetFeedbackByProjectIdAsync',
      params: { projectId: id },
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
    }

    //KMI Contact Filter = CXCO-726
    getKMIDataByProjectId(id: number): Observable<ApiResult<any>> {
        return this.http.get<Kmi[]>({
            url: 'Applicant/GetKMIDataByProjectIdAsync',
            params: { projectId: id },
            pleaseWaitTimeoutDuration: 500,
            pleaseWaitMessage: 'Processing.',
            pleaseWaitContainerId: 'ContainerAwaiter'
        });
    }

    //KMI Data bind = CXCO-726
    bindKMIDataByProjectId(id: number): Observable<ApiResult<any>> {
        return this.http.get<KMIUpdate>({
            url: 'Common/BindKMIDataAsync',
            params: { projectId: id },
            pleaseWaitTimeoutDuration: 500,
            pleaseWaitMessage: 'Processing.',
            pleaseWaitContainerId: 'ContainerAwaiter'
        });
    }

    //KMI Data Update = CXCO-726
    PutKMIData(model: KMIUpdate): Observable<ApiResult<any>> {
        return this.http.put<KMIUpdate>({
            url: 'Common/PutKMIDataAsync',
            data: model,
            shouldIgnoreInvalidResult: false,
            pleaseWaitTimeoutDuration: 500,
            pleaseWaitMessage: 'Processing.',
            pleaseWaitContainerId: 'ContainerAwaiter'
        });
    }

    //KMI Data Update = CXCO-726
    GetKMITransactionStatusData(CAGETORY: string): Observable<ApiResult<any>> {
        return this.http.get<KMI_Configurations>({
            url: 'Common/BindKMI_ConfigurationsAsync',
            params: { Category: CAGETORY },
            shouldIgnoreInvalidResult: false,
            pleaseWaitTimeoutDuration: 500,
            pleaseWaitMessage: 'Processing.',
            pleaseWaitContainerId: 'ContainerAwaiter'
        });
    }
}
